import { render, staticRenderFns } from "./TestStatisticsReport.vue?vue&type=template&id=c4b379d0&scoped=true"
import script from "./TestStatisticsReport.vue?vue&type=script&lang=js"
export * from "./TestStatisticsReport.vue?vue&type=script&lang=js"
import style0 from "./TestStatisticsReport.vue?vue&type=style&index=0&id=c4b379d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b379d0",
  null
  
)

export default component.exports